import { Auth } from "aws-amplify";
import axios from "axios";
import { toast } from "react-toastify";

import { isUserLogined } from "../context/useAuth";
import { delay, getUserJwtToken, handleAPICallError, redirectLogin } from "../utils/helperFunctions";
import { CONFIGS } from "../constants/AppConstant";

const SVC_URL = CONFIGS.PROFILE_SVC_URL;

const client = axios.create({
  baseURL: SVC_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "x-api-key": "UserProfileServiceasklfhaskjfhaslkjhjkwoj",
  },
});

const API_PATH = {
  creditCard: "/creditCard",
};

async function getCreditCards({ callback }) {
  if (!(await isUserLogined())) {
    callback({});
    return;
  }
  const user = await Auth.currentAuthenticatedUser();

  const jwtToken = getUserJwtToken(user);
  client
    .get(`${API_PATH.creditCard}`, {
      headers: {
        Authorization: jwtToken,
      },
    })
    .then((res) => {
      //   console.log("Success:", res);
      const { data } = res;
      callback({ data });
    })
    .catch((error) => {
      handleAPICallError({ err: error, callback });
    });
}

// async function updateUserProfile({ newProfile, callback }) {
//   if (!(await isUserLogined())) {
//     toast.warn("Please login first!");
//     await delay(1);
//     redirectLogin();
//     return;
//   }
//   const user = await Auth.currentAuthenticatedUser();
//   const jwtToken = getUserJwtToken(user);
//   return client
//     .put(`${API_PATH.profile}`, newProfile, {
//       headers: {
//         Authorization: jwtToken,
//       },
//     })
//     .then((res) => {
//       const {
//         data: { userProfile = {} },
//         data,
//       } = res;
//       callback({ userProfile });
//     })
//     .catch((error) => {
//       handleAPICallError({ err: error, callback });
//     });
// }

async function createCreditCard({ payload, callback }) {
  if (!(await isUserLogined())) {
    toast.warn("Please login first!");
    await delay(1);
    redirectLogin();
    return;
  }
  const user = await Auth.currentAuthenticatedUser();
  const jwtToken = getUserJwtToken(user);
  client
    .post(`${API_PATH.creditCard}`, payload, {
      headers: {
        Authorization: jwtToken,
      },
    })
    .then((res) => {
      const { data } = res;
      callback({ data });
    })
    .catch((error) => {
      handleAPICallError({ err: error, callback });
    });
}

async function updateCreditCard({ payload, callback }) {
  if (!(await isUserLogined())) {
    toast.warn("Please login first!");
    await delay(1);
    redirectLogin();
    return;
  }
  const user = await Auth.currentAuthenticatedUser();
  const jwtToken = getUserJwtToken(user);
  client
    .put(`${API_PATH.creditCard}`, payload, {
      headers: {
        Authorization: jwtToken,
      },
    })
    .then((res) => {
      const { data } = res;
      callback({ data });
    })
    .catch((error) => {
      handleAPICallError({ err: error, callback });
    });
}

export default {
  getCreditCards,
  createCreditCard,
  updateCreditCard,
};
